import { render, staticRenderFns } from "./ReferralsViewDetails.vue?vue&type=template&id=7cc252e8&scoped=true"
import script from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
export * from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReferralsViewDetails.vue?vue&type=style&index=0&id=7cc252e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc252e8",
  null
  
)

export default component.exports